import React from 'react';
import styled from 'styled-components';
import { WLItem } from 'src/components/Wishlists/WishlistItem';
import { BoxButton } from '@riac/design-system';
import { Select, SelectTrigger } from '@riac/design-system';
import { Item } from '@react-stately/collections';
import { IWishlist, IWishlistItem } from 'src/lib/WishlistTypes.i';

const StyledSelect = styled(Select)`
  gap: 0;

  ${SelectTrigger} {
    padding: 0.5em 0;
    border: solid 1px black;
  }
`;

const ContentWrapper = styled.div`
  min-height: 320px;
`;

export const ShowWishlist = ({
  currentListId,
  auctionWishlists,
  setCurrentListId,
  itemList,
  setItemList,
  closeModal,
}):JSX.Element => {
  return (
    <ContentWrapper>
      <h4>Wishlists</h4>
      <StyledSelect
        label = 'Select Wishlist to View'
        value = {currentListId.toString()}
        onChange = {(value:string) => {
          setCurrentListId(value);
        }}
        inverted
        noOptionsBorder
        noMargin
      >
        {auctionWishlists?.map((wl:IWishlist) => (
          <Item key = {wl.WishListID.toString()}>
            {wl.WishListName}
          </Item>
        ))}
      </StyledSelect>
      <div>
        {itemList.map((item:IWishlistItem) => (
          <WLItem
            wishlistId={currentListId}
            item={item}
            key={item.AuctionItemID}
            removeFromList={(wlId) =>
              setItemList((list:IWishlistItem[]) => list.filter((item:IWishlistItem) => item.WishListItemID !== wlId))
            }
          />
        ))}
      </div>
      <div>
        <BoxButton onPress={() => closeModal()}>
          Close
        </BoxButton>
      </div>
    </ContentWrapper>
  );
};
